"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _UrlParts = _interopRequireDefault(require("../parts/UrlParts"));

var BLACKLISTED_WRAPPING_CHARS = '\\s\\(\\)\\[\\]\\{\\}';

var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$isGlobal = _ref.isGlobal,
      isGlobal = _ref$isGlobal === void 0 ? false : _ref$isGlobal,
      _ref$domain = _ref.domain,
      domain = _ref$domain === void 0 ? _UrlParts.default.domain : _ref$domain,
      _ref$protocol = _ref.protocol,
      protocol = _ref$protocol === void 0 ? _UrlParts.default.protocol : _ref$protocol,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? _UrlParts.default.path : _ref$path,
      _ref$file = _ref.file,
      file = _ref$file === void 0 ? _UrlParts.default.file : _ref$file,
      _ref$search = _ref.search,
      search = _ref$search === void 0 ? _UrlParts.default.search : _ref$search;

  var flags = 'i';
  var urlRegexStr = protocol + "?" + domain + "(?:" + path + "(?:" + file + ")?)?" + search + "?";

  if (isGlobal) {
    flags = flags + "g";
    urlRegexStr = "[^" + BLACKLISTED_WRAPPING_CHARS + "]*?" + urlRegexStr + "[^" + BLACKLISTED_WRAPPING_CHARS + "]*?";
  } else {
    urlRegexStr = "^" + urlRegexStr + "$";
  }

  return new RegExp(urlRegexStr, flags);
};

exports.default = _default;
module.exports = exports.default;